var map = {
	"./certificate_image.png": 1238,
	"./complated.png": 1239,
	"./download_icon.png": 622,
	"./facebook_icon.png": 623,
	"./linkedin_icon.png": 624,
	"./logo.png": 1240,
	"./pending.png": 1241,
	"./score_icon.png": 1242,
	"./training.png": 1243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1237;